import { useQuery } from 'react-query';
import { api } from 'src/api/axios';

export const useDetailTemplate = (id: number) =>
  useQuery(
    ['detailTemplate', id],
    async () => {
      if (id) {
        const res = await api.get(`/api/cms/template-design/${id}`);
        return res.data.data;
      }
      return;
    },
    {
      retry: 0,
    }
  );
